import React, { useState, useEffect } from "react";
import UploadBanner from "../../components/banners/UploadBanner";
import { Container } from "reactstrap";
import cx from "classnames";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import { connect } from "react-redux";
import * as userAction from "../../actions/user-action-type";
import { withRouter } from "react-router-dom";
import { getLanguage, setLanguage, useTranslation } from "react-multi-lang";
import { Component } from "react";
import { Link } from "react-router-dom";
import "../BookYourExperience/style.scss";
import "./custom.css";
import leftLineArrow from "../../assets/images/icons/line-arrow-left.svg";
import headBanner from "../../assets/images/adventure-banner.jpeg";
import bannerImage from "../../assets/images/Featured.jpg";
import PackagesViewSlider from "./PackagesViewSlider";
import mapIcon from "../../assets/images/icons/maps-and-flags.png";
import ContentLoader from "react-content-loader";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function LoaderCard(props) {
  return (
    <ContentLoader
      speed={2}
      viewBox="0 0 1200 300"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      {...props}
    >
      <rect x="0" y="0" rx="8" ry="8" width="400" height="300" />
      <rect x="430" y="20" rx="4" ry="4" width="600" height="25" />
      <rect x="430" y="60" rx="3" ry="3" width="700" height="15" />
      <rect x="430" y="85" rx="3" ry="3" width="680" height="15" />
      <rect x="430" y="110" rx="3" ry="3" width="720" height="15" />
      <rect x="430" y="135" rx="3" ry="3" width="650" height="15" />
      <rect x="430" y="240" rx="6" ry="6" width="150" height="40" />
    </ContentLoader>
  );
}

function RenderBookCard(props) {
  const [imgLoad, setImageLoad] = useState(false);
  const {
    package_name,
    arabic_name,
    url_slug,
    price,
    original_price,
    child_price,
    rating,
    img,
    destination_id,
    destinationData,
    offer_tag,
    offer_tag_text,
    slug,
    description,
    short_description,
    redirect,
    redirect_url,
  } = props;
  const history = useHistory();
  const t = useTranslation();
  const [destName, setDestName] = useState("");
  useEffect(() => {
    for (var i = 0; i < destinationData?.length; i++) {
      if (destinationData[i]["id"] === destination_id) {
        setDestName(destinationData[i].name);
      }
    }
  }, [destinationData, destination_id]);

  // Get destination name directly for GTM
  const getDestinationName = () => {
    if (!destinationData) return "";
    const destination = destinationData.find((d) => d.id === destination_id);
    return destination ? destination.name : "";
  };

  const top = () => (
    <div className="top-content">
      {destName != "" ? (
        <div>
          <p className="rating">
            <img src={mapIcon} alt="rating" />
            {destName}
          </p>
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );

  const bottom = () => (
    <div className="bottom-div">
      <div className="card-content-wrapper">
        {localStorage.getItem("user_language") === "en" ? (
          <h3 className="card-title">{package_name}</h3>
        ) : (
          <h3 className="card-title">{arabic_name}</h3>
        )}
        <div
          className="description-text"
          dangerouslySetInnerHTML={{
            __html:
              description ||
              short_description ||
              "Discover amazing experiences and create unforgettable memories at this destination. Book your adventure today!",
          }}
        />
        <button
          className="know-more-button"
          onClick={(e) => {
            e.stopPropagation();
            if (window.dataLayer) {
              const packageTitle =
                localStorage.getItem("user_language") === "en"
                  ? package_name
                  : arabic_name;
              const packagePrice = price || child_price || "0";
              const destinationName = getDestinationName();

              window.dataLayer.push({
                event: "package_click",
                package_data: {
                  title: packageTitle || "",
                  price: packagePrice,
                  original_price: original_price || "0",
                  destination: destinationName,
                  url_slug: window.location.origin + "/p/" + (url_slug || ""),
                },
              });
            }
            if (redirect === "1") {
              // Convert full URL to relative path if same domain
              const url = redirect_url || "";
              if (url.includes("discovershurooq.ae")) {
                const relativePath = url.replace(/https?:\/\/[^\/]+/, "");
                history.push(relativePath);
              } else {
                window.location.href = url;
              }
            } else {
              history.push(`/p/${url_slug}`);
            }
          }}
        >
          {redirect === "1" ? "KNOW MORE" : "BOOK NOW"}
        </button>
      </div>
    </div>
  );
  const image =
    "https://api.discovershurooq.ae/cdn-cgi/image/width=900,height=500,quality=85,format=auto/files/" +
    img;

  return (
    <div className="activity-item">
      {offer_tag == 1 ? (
        <div className="ribbon ribbon-top-left">
          <span>{offer_tag_text}</span>
        </div>
      ) : null}
      <div
        className="activity-content"
        data-gtm-title={
          localStorage.getItem("user_language") === "en"
            ? package_name
            : arabic_name
        }
        data-gtm-price={price != "" ? price : child_price}
        data-gtm-original-price={original_price || ""}
        data-gtm-destination={destName}
        data-gtm-url-slug={url_slug}
        onClick={() => {
          if (window.dataLayer) {
            const packageTitle =
              localStorage.getItem("user_language") === "en"
                ? package_name
                : arabic_name;
            const packagePrice = price || child_price || "0";
            const destinationName = getDestinationName();

            window.dataLayer.push({
              event: "package_click",
              package_data: {
                title: packageTitle || "",
                price: packagePrice,
                original_price: original_price || "0",
                destination: destinationName,
                url_slug: window.location.origin + "/p/" + (url_slug || ""),
              },
            });

            console.log("GTM Push:", {
              event: "package_click",
              package_data: {
                title: packageTitle || "",
                price: packagePrice,
                original_price: original_price || "0",
                destination: destinationName,
                url_slug: window.location.origin + "/p/" + (url_slug || ""),
              },
            });
          }
          if (redirect === "1") {
            // Convert full URL to relative path if same domain
            const url = redirect_url || "";
            if (url.includes("discovershurooq.ae")) {
              const relativePath = url.replace(/https?:\/\/[^\/]+/, "");
              history.push(relativePath);
            } else {
              window.location.href = url;
            }
          } else {
            history.push(`/p/${url_slug}`);
          }
        }}
      >
        <div className="activity-image-wrapper">
          <LazyLoadImage
            className="activity-image"
            src={image}
            alt={package_name}
            effect="blur"
            placeholderSrc={`https://api.discovershurooq.ae/cdn-cgi/image/width=100,quality=50,format=auto/files/${img}`}
          />
        </div>
        <div className="activity-details">{bottom()}</div>
      </div>
    </div>
  );
}

const AdventurousDetails = (props) => {
  const history = useHistory();
  localStorage.setItem("pathname", history.location.pathname);
  const btns = [{ active: "true" }, {}, {}, {}];
  const { slug } = props.match.params;
  const [activeTab, setActiveTab] = useState(0);
  const {
    tagData,
    getTagData,
    settingData,
    getSettingData,
    destinationData,
    getDestinationData,
  } = props;

  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const data = new FormData();
    data.append("action", "packagesByTags");
    data.append("tag", slug);
    getTagData(data);

    const destData = new FormData();
    destData.append("action", "destinations");
    getDestinationData(destData);

    const formData = new FormData();
    formData.append("action", "discover_shurooq_homepage_settings");
    getSettingData(formData);
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  // function clickedTag(id, value) {
  //   setActiveTab(id);
  //   if (id === 0) {
  //     const data = new FormData();
  //     data.append('action', 'packagesByCategory');
  //     data.append('tag', value);
  //     getTagData(data);
  //   } else {
  //     const data = new FormData();
  //     data.append('action', 'packagesByTags');
  //     data.append('tag', value);
  //     getTagData(data);
  //   }
  // }

  const renderLoader = () => (
    <div className="activities-list">
      {["", "", ""].map((data, index) => (
        <div key={"bookData" + index} className="activity-loader">
          <LoaderCard />
        </div>
      ))}
    </div>
  );

  const renderData = () => (
    <div className="activities-list">
      {tagData.length === 0 ? (
        <div style={{ justifyContent: "center", display: "flex" }}>
          <p>No Packages Found</p>
        </div>
      ) : null}
      {tagData
        .sort((a, b) => a.position - b.position)
        .map((data, index) =>
          data.enable === "1" && data.checkout?.includes("DiscoverShurooq") ? (
            <RenderBookCard
              key={"bookData" + index}
              {...data}
              destinationData={destinationData}
              slug={slug}
            />
          ) : null
        )}
    </div>
  );

  useEffect(() => {
    setTimeout(() => setLoader(false), 2000);
  }, [tagData]);

  return (
    <div>
      <UploadBanner
        // linkPage={[{ type: "link", name: "Home", link: "/" }, { name: `DiscoverShurooq - ${slug}` }]}
        backgroundImage={`https://api.discovershurooq.ae/files/banners/${encodeURI(
          slug
        )}.png`}
      />
      <section className="book-youre-experience-section">
        <Container>
          <h2 className="sec-title">
            <span className="sec-title-capital">{slug}</span>
          </h2>
          {/* <div className="tab-box-btn">
            <div className="wrapper">
              {btns.map(({ active = false }, indexKey) => (
                <button key={"btn" + indexKey} className={cx({ active: active })}>
                  Tag text
                </button>
              ))}
            </div>
          </div> */}
          {loader ? renderLoader() : renderData()}
        </Container>

        {/* <div className="UploadCard">
          <Row>
            <Col md={12}>
              <div className="mainview">
                <div className="content-view" style={{ paddingTop: 90 }}>
                  <div className="main-view-packages">
                    {tagData != null && tagData != "" &&
                      <PackagesViewSlider tagData={tagData} />
                    }
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </div> */}
      </section>
    </div>
  );
};

const mapStateToProps = ({
  user: { tagData, settingData, destinationData },
}) => ({
  tagData,
  settingData,
  destinationData,
});

const mapDispatchToProps = {
  getTagData: userAction.getTagData,
  getSettingData: userAction.getSettingData,
  getDestinationData: userAction.getDestinationData,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(AdventurousDetails));
